import { Component } from "@angular/core";
import { ActivatedRoute, Params } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { ICardboardService } from "src/app/services/cardboard/cardboard.interface";
import { environment } from "src/environments/environment";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatChipsModule } from "@angular/material/chips";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: "app-signature-status",
  templateUrl: "./signature-status.component.html",
  styleUrl: "./signature-status.component.css",
  imports: [
    TranslateModule, 
    CommonModule, 
    MatTooltipModule,
    MatIconModule,
    MatProgressBarModule,
    MatChipsModule,
    MatProgressSpinnerModule
  ],
  standalone: true,
})
export class SignatureStatusComponent {
  public cardboardURL: string = environment.cardboardURL;
  public signerId: string = "";
  public errorStatus: string = "";
  public signatureObject: any = null;

  constructor(
    private cardboardService: ICardboardService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.paramMap.subscribe((paramMap: any) => {
      this.signerId = paramMap.params.signerId;
      this.getSignatureStatus();
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.errorStatus = params?.error;
    });
  }

  getSignatureStatus(): void {
    if (!this.signerId) return;

    this.cardboardService.getSignatureStatus(this.signerId).subscribe((response: any) => {
      if(response) {
        this.signatureObject = response;
      }
    });
  }

  getProgressPercentage(): number {
    if (!this.signatureObject?.members) return 0;
    
    const totalMembers = this.signatureObject.members.length;
    if (totalMembers === 0) return 0;
    
    const signedCount = this.getSignedCount();
    return Math.round((signedCount / totalMembers) * 100);
  }

  getSignedCount(): number {
    if (!this.signatureObject?.members) return 0;
    return this.signatureObject.members.filter((member: any) => member.signed).length;
  }

  isExpiringSoon(expiresAt: string): boolean {
    if (!expiresAt) return false;
    
    const expirationDate = new Date(expiresAt);
    const now = new Date();
    const daysUntilExpiration = (expirationDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
    
    return daysUntilExpiration <= 7 && daysUntilExpiration > 0;
  }
}
